import { Injectable } from '@angular/core';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { MessageService } from 'primeng/api';
import { UtilsService } from './utils.service';

interface Message {
    summary?: string;
    details: string;
    placeholderValue?: { [key: string]: string };
    life?: number;
}

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    constructor(
        private _messageService: MessageService,
        private translateService: CustomTranslateService,
        private utilsService: UtilsService,
    ) {}

    clearMessageQueue() {
        this._messageService.clear();
    }

    private createMessage(msg: Message, severity: string, clearQueue?: boolean): void {
        if (clearQueue) {
            this.clearMessageQueue();
        }

        const summary: string = msg.summary
            ? this.translateService.instant(msg.summary)
            : this.translateService.instant(msg.details, msg.placeholderValue);

        const detail: string | undefined = !msg.summary
            ? undefined
            : this.translateService.instant(msg.details, msg.placeholderValue);

        this._messageService.add({
            severity,
            summary,
            detail,
            life: msg.life ?? this.getDefaultLife(severity),
        });
    }

    private getDefaultLife(severity: string): number {
        switch (severity) {
            case 'error':
                return 5000;
            case 'warn':
                return 5000;
            default:
                return 2000;
        }
    }

    showSuccess(msg: Message, clearQueue?: boolean): void {
        this.createMessage(msg, 'success', clearQueue);
    }

    showInfo(msg: Message, clearQueue?: boolean): void {
        this.createMessage(msg, 'info', clearQueue);
    }

    showWarning(msg: Message, clearQueue?: boolean): void {
        this.createMessage(msg, 'warn', clearQueue);
    }

    showError(msg: Message, clearQueue?: boolean): void {
        this.createMessage(msg, 'error', clearQueue);
    }
}
